import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "message-bubble"
};
var _hoisted_2 = {
  "class": "message-body"
};
var _hoisted_3 = {
  key: 0,
  "class": "message-body-nickName"
};
var _hoisted_4 = {
  "class": "content-main"
};
var _hoisted_5 = {
  key: 0,
  "class": "content-has-risk-tips"
};
import { computed, toRefs } from "../../../../adapter-vue";
import TUIChatEngine, { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import Icon from "../../../common/Icon.vue";
import ReadStatus from "./read-status/index.vue";
import MessageQuote from "./message-quote/index.vue";
import Avatar from "../../../common/Avatar/index.vue";
import loadingIcon from "../../../../assets/icon/loading.png";
import { shallowCopyMessage } from "../../utils/utils";
import { isPC } from "../../../../utils/env";
var riskImageReplaceUrl = "https://web.sdk.qcloud.com/component/TUIKit/assets/has_risk_default.png";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-bubble',
  props: {
    messageItem: {
      "default": function _default() {
        return {};
      }
    },
    content: {
      "default": function _default() {
        return {};
      }
    },
    blinkMessageIDList: {
      "default": function _default() {
        return [];
      }
    }
  },
  emits: ["resendMessage", "blinkMessage", "setReadReciptPanelVisible", "scrollTo"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var TYPES = TUIChatEngine.TYPES;
    var needLoadingIconMessageType = [TYPES.MSG_LOCATION, TYPES.MSG_TEXT, TYPES.MSG_CUSTOM, TYPES.MSG_MERGER, TYPES.MSG_FACE];
    var _toRefs = toRefs(props),
      blinkMessageIDList = _toRefs.blinkMessageIDList,
      message = _toRefs.messageItem;
    var isNoPadding = computed(function () {
      return [TYPES.MSG_IMAGE, TYPES.MSG_VIDEO].includes(message.value.type);
    });
    var riskContentText = computed(function () {
      var content = TUITranslateService.t("TUIChat.涉及敏感内容") + ", ";
      if (message.value.flow === "out") {
        content += TUITranslateService.t("TUIChat.发送失败");
      } else {
        content += TUITranslateService.t(message.value.type === TYPES.MSG_AUDIO ? "TUIChat.无法收听" : "TUIChat.无法查看");
      }
      return content;
    });
    var isBlink = computed(function () {
      var _message$value;
      if ((_message$value = message.value) !== null && _message$value !== void 0 && _message$value.ID) {
        var _blinkMessageIDList$v;
        return blinkMessageIDList === null || blinkMessageIDList === void 0 || (_blinkMessageIDList$v = blinkMessageIDList.value) === null || _blinkMessageIDList$v === void 0 ? void 0 : _blinkMessageIDList$v.includes(message.value.ID);
      }
      return false;
    });
    function resendMessage() {
      var _message$value2;
      if (!((_message$value2 = message.value) !== null && _message$value2 !== void 0 && _message$value2.hasRiskContent)) {
        emits("resendMessage");
      }
    }
    function blinkMessage(messageID) {
      emits("blinkMessage", messageID);
    }
    function scrollTo(scrollHeight) {
      emits("scrollTo", scrollHeight);
    }
    function openReadUserPanel() {
      emits("setReadReciptPanelVisible", true, message.value);
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        "class": _normalizeClass(["message-bubble-main-content", [_unref(message).flow === 'in' ? '' : 'reverse']])
      }, [_createVNode(Avatar, {
        useSkeletonAnimation: "",
        url: _unref(message).avatar || ''
      }, null, 8, ["url"]), _createElementVNode("main", _hoisted_2, [_unref(message).flow === 'in' && _unref(message).conversationType === 'GROUP' ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.content.showName), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
        "class": _normalizeClass(['message-body-main', _unref(message).flow === 'out' && 'message-body-main-reverse'])
      }, [_createElementVNode("div", {
        "class": _normalizeClass(['blink', 'message-body-content', _unref(message).flow === 'out' ? 'content-out' : 'content-in', _unref(message).hasRiskContent && 'content-has-risk', _unref(isNoPadding) ? 'content-noPadding' : '', _unref(isNoPadding) && _unref(isBlink) ? 'blink-shadow' : '', !_unref(isNoPadding) && _unref(isBlink) ? 'blink-content' : ''])
      }, [_createElementVNode("div", _hoisted_4, [(_unref(message).type === _unref(TYPES).MSG_IMAGE || _unref(message).type === _unref(TYPES).MSG_VIDEO) && _unref(message).hasRiskContent ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        "class": _normalizeClass(['message-risk-replace', !_unref(isPC) && 'message-risk-replace-h5']),
        src: riskImageReplaceUrl
      }, null, 2)) : _renderSlot(_ctx.$slots, "default", {
        key: 1
      })]), _unref(message).hasRiskContent ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(riskContentText)), 1)) : _createCommentVNode("", true)], 2), _unref(message).status === 'fail' || _unref(message).hasRiskContent ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "message-label fail",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return resendMessage();
        })
      }, " ! ")) : _createCommentVNode("", true), _unref(message).status === 'unSend' && needLoadingIconMessageType.includes(_unref(message).type) ? (_openBlock(), _createBlock(Icon, {
        key: 1,
        "class": "message-label loadingCircle",
        file: _unref(loadingIcon),
        width: '15px',
        height: '15px'
      }, null, 8, ["file"])) : _createCommentVNode("", true), _createVNode(ReadStatus, {
        "class": "message-label align-self-bottom",
        message: _unref(shallowCopyMessage)(_unref(message)),
        onOpenReadUserPanel: openReadUserPanel
      }, null, 8, ["message"])], 2)])], 2), _createElementVNode("div", {
        "class": _normalizeClass(["message-bubble-extra-content", _unref(message).flow === 'in' || 'reverse'])
      }, [_createVNode(MessageQuote, {
        message: _unref(message),
        onBlinkMessage: blinkMessage,
        onScrollTo: scrollTo
      }, null, 8, ["message"])], 2)]);
    };
  }
});